import {FC, ReactNode} from "react"

interface HeadlineTextProps {
  children: ReactNode
}

export const HeadlineText: FC<HeadlineTextProps> = ({children}) => (
  <p className="mt-4 text-body-2">{children}</p>
)
